import React from "react";

export default function Destinations() {
  return (
    <section className="px-4 border-t py-14 md:py-24 border-brand-gray-light">
      <div className="container mx-auto">
        <div className="grid xl:grid-cols-12 gap-10 xl:gap-6  2xl:gap-12">
          <div className="xl:col-span-9">
            <div className="flex justify-between items-center mb-10">
              <h3 className="text-xl md:text-2xl text-brand-dark font-medium font-poppins">
                Top Destinations
              </h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.707"
                height="7.061"
                viewBox="0 0 12.707 7.061"
              >
                <g
                  id="Group_21"
                  dataname="Group 21"
                  transform="translate(0.354 0.354)"
                >
                  <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M20,10l-6,6L8,10"
                    transform="translate(-8 -10)"
                    fill="none"
                    stroke="#00113f"
                    strokeWidth="1"
                  />
                </g>
              </svg>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 2xl:gap-8">
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Africa
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Europe
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Egypt
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Bali
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Japan
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Sri Lanka
                </a>
              </div>
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Croatia
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Great Britain & UK
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Italy
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Iceland
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Scandinavia
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Scotland
                </a>
              </div>
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Canada
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Asia
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Latin America
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Morocco
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  China
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Rhine River Cruises
                </a>
              </div>
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  New Zealand
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Thailand
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Danube River Cruises
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Greece
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Ireland
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Portugal
                </a>
              </div>
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Spain
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Costa Rica
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Turkey
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Australia
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  South America
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  South America
                </a>
              </div>
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  India
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Philippines
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Vietnam
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Eastern Europe
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Greek Islands
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  USA
                </a>
              </div>
            </div>
          </div>
          <div className="xl:col-span-3">
            <div className="flex justify-between items-center  mb-10">
              <h3 className="text-xl md:text-2xl text-brand-dark font-medium font-poppins">
                Top Adventure Styles
              </h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.707"
                height="7.061"
                viewBox="0 0 12.707 7.061"
              >
                <g
                  id="Group_21"
                  dataname="Group 21"
                  transform="translate(0.354 0.354)"
                >
                  <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M20,10l-6,6L8,10"
                    transform="translate(-8 -10)"
                    fill="none"
                    stroke="#00113f"
                    strokeWidth="1"
                  />
                </g>
              </svg>
            </div>
            <div className="grid grid-cols-2 gap-8">
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Adventure
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Bicycle
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Hiking & Trekking
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Northern Lights
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  River Cruise
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Africa Safari
                </a>
              </div>
              <div className="grid gap-4">
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  In-Depth Cultural
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Coach / Bus
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Train / Rail
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Beach
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Family
                </a>
                <a
                  href="#"
                  target="_blank"
                  className="text-base 2xl:text-lg inline-block text-brand-gray-500 hover:underline hover:text-brand-red"
                >
                  Private
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
